import { useState, useCallback, useEffect } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { addItemGroup, updateItemGroup } from 'helpers/backend_helper';
import { Common } from 'helpers/common';

export const useItemGroupModal = (onSave: (result: any) => void, initialData?: any) => {
    const [show, setShow] = useState<boolean>(false);
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [itemGroupData, setItemGroupData] = useState<any>(initialData);
    const [isSaving, setIsSaving] = useState<boolean>(false);
    const commonHelper = new Common();

    useEffect(() => {
        if (initialData) {
            setItemGroupData(initialData);
            setIsEdit(!!initialData.id);
        }
    }, [initialData]);

    const toggle = useCallback(() => {
        setShow(!show);
        if (show) {
            setItemGroupData(null);
        }
    }, [show]);

    const handleEditDataClick = (ele: any) => {
        setItemGroupData({ ...ele });
        setIsEdit(true);
        setShow(true);
    };

    const handleAddItemGroup = () => {
        setItemGroupData({});
        toggle();
    };

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            group_name: itemGroupData?.group_name || "",
            description: itemGroupData?.description || ""
        },
        validationSchema: Yup.object({
            group_name: Yup.string().required("Please enter group name"),
            description: Yup.string().required("Please enter description")
        }),
        onSubmit: async (values: any) => {
            setIsSaving(true);
            try {
                let result;
                if (isEdit) {
                    result = await updateItemGroup({ ...values, id: itemGroupData.id });
                    commonHelper.showSuccessMessage("Item Group updated successfully");
                } else {
                    result = await addItemGroup(values);
                    commonHelper.showSuccessMessage("Item Group added successfully");
                }
                
                if (result) {
                    onSave(result);
                }
            } catch (error) {
                console.error('Error saving item group:', error);
                commonHelper.showErrorMessage(isEdit ? "Failed to update item group" : "Failed to add item group");
            } finally {
                setIsSaving(false);
            }
        }
    });

    return {
        show,
        isEdit,
        itemGroupData,
        toggle,
        handleEditDataClick,
        handleAddItemGroup,
        validation,
        isSaving
    };
};